import React from 'react';
import { Badge, FormGroup, ControlLabel } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Field = ({ direction, register, languageName, languageCode, value }) => (
  <FormGroup className={classNames(`services-categories__${direction}`)}>
    <ControlLabel>
      Category name
      {' '}
      <Badge>{languageName}</Badge>
    </ControlLabel>
    <input className="form-control" name={languageCode} defaultValue={value} {...register(`name.${languageCode}`)} />
  </FormGroup>
);

Field.propTypes = {
  direction: PropTypes.any,
  register: PropTypes.any,
  languageName: PropTypes.any,
  languageCode: PropTypes.any,
  value: PropTypes.any,
};

export default Field;
